import React from 'react'


function Universe() {
    return (
        <div className='container text-center p-5 my-5'>
            <div>
                <div className='fs-4'>
                    <p>Want to know more about our technology stack? Check out the <a style={{ textDecoration: 'none' }} href=''>Zerodha.tech</a> blog.</p>
                </div>
                <div className='m-5 p-5'>
                    <h2>The Zerodha Universe</h2>
                    <p className='fs-5'>Extend your trading and investment experience even further with our partner platforms</p>
                </div>
                <div className='row m-5'>
                    <div className='col'>
                        <a href='https://www.zerodhafundhouse.com/'  style={{ textDecoration: 'none' }} >
                            <img style={{ width: '190px' }} src='media/zerodhaFundhouse.png' alt='' />
                            <p style={{ width: '350px', paddingBlock: '20px', color: 'gray' }} >
                                Our asset management venture
                                that is creating simple and transparent index
                                funds to help you save for your goals.
                            </p>
                        </a>
                    </div>
                    <div className='col'>
                        <a href='https://www.zerodhafundhouse.com/'  style={{ textDecoration: 'none' }} >
                            <img style={{ width: '240px' }} src='media/sensibullLogo.svg' alt='' />
                            <p style={{ width: '350px', paddingBlock: '20px', color: 'gray' }}  >
                                Options trading platform that lets you
                                create strategies, analyze positions, and examine
                                data points like open interest, FII/DII, and more.
                            </p>
                        </a>
                    </div>
                    <div className='col'>
                        <a href='https://www.zerodhafundhouse.com/'  style={{ textDecoration: 'none' }} >
                            <img style={{ width: '190px' }} src='media/tijori.svg' alt='' />
                            <p style={{ width: '350px', paddingBlock: '10px', color: 'gray' }} >
                                Investment research platform
                                that offers detailed insights on stocks,
                                sectors, supply chains, and more.
                            </p>
                        </a>
                    </div>
                </div>
                <div className='row m-5'>
                    <div className='col'>
                        <a href='https://www.zerodhafundhouse.com/'  style={{ textDecoration: 'none' }} >
                            <img style={{ width: '190px' }} src='media/StreakLogo.png' alt='' />
                            <p style={{ width: '350px', paddingBlock: '20px', color: 'gray' }} >
                                Systematic trading platform
                                that allows you to create and backtest
                                strategies without coding.
                            </p>
                        </a>
                    </div>
                    <div className='col'>
                        <a href='https://www.zerodhafundhouse.com/'  style={{ textDecoration: 'none' }} >
                            <img style={{ width: '240px' }} src='media/smallcaseLogo.png' alt='' />
                            <p style={{ width: '350px', paddingBlock: '20px', color: 'gray' }}  >
                                Thematic investing platform
                                that helps you invest in diversified
                                baskets of stocks on ETFs.
                            </p>
                        </a>
                    </div>
                    <div className='col'>
                        <a href='https://www.zerodhafundhouse.com/'  style={{ textDecoration: 'none' }} >
                            <img style={{ width: '190px' }} src='media/dittoLogo.png' alt='' />
                            <p style={{ width: '350px', paddingBlock: '10px', color: 'gray' }} >
                                Personalized advice on life
                                and health insurance. No spam
                                and no mis-selling.
                            </p>
                        </a>
                    </div>
                    
                </div>
                <div className='row'>
                    <a href="signup">
                        <button className='p-2 btn btn-primary fs-6 mb-5' style={{width: "15%", margin: "0 auto"}}>Sign up for free </button>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Universe;